/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { AmendHousekeepingPlanRequest } from '../model'
// @ts-ignore
import type { CreateHousekeepingPlanRequest } from '../model'
// @ts-ignore
import type { CreateHousekeepingPlanResponse } from '../model'
// @ts-ignore
import type { HousekeepingPlanResponse } from '../model'
// @ts-ignore
import type { HousekeepingPlanSummaryResponse } from '../model'
/**
 * HousekeepingPlansApi - axios parameter creator
 */
export const HousekeepingPlansApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} id
     * @param {AmendHousekeepingPlanRequest} [amendHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amendHousekeepingPlan: async (
      id: string,
      amendHousekeepingPlanRequest?: AmendHousekeepingPlanRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('amendHousekeepingPlan', 'id', id)
      const localVarPath = `/yard/api/HousekeepingPlans/{id}/Amend`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        amendHousekeepingPlanRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelHousekeepingPlan: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cancelHousekeepingPlan', 'id', id)
      const localVarPath = `/yard/api/HousekeepingPlans/{id}/Cancel`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateHousekeepingPlanRequest} [createHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHousekeepingPlan: async (
      createHousekeepingPlanRequest?: CreateHousekeepingPlanRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/HousekeepingPlans/CreateHousekeepingPlan`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createHousekeepingPlanRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHousekeepingPlanById: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getHousekeepingPlanById', 'id', id)
      const localVarPath = `/yard/api/HousekeepingPlans/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHousekeepingPlans: async (
      ids?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/HousekeepingPlans`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['ids'] = ids
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HousekeepingPlansApi - functional programming interface
 */
export const HousekeepingPlansApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HousekeepingPlansApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {AmendHousekeepingPlanRequest} [amendHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async amendHousekeepingPlan(
      id: string,
      amendHousekeepingPlanRequest?: AmendHousekeepingPlanRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HousekeepingPlanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.amendHousekeepingPlan(
        id,
        amendHousekeepingPlanRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HousekeepingPlansApi.amendHousekeepingPlan']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelHousekeepingPlan(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HousekeepingPlanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelHousekeepingPlan(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HousekeepingPlansApi.cancelHousekeepingPlan']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateHousekeepingPlanRequest} [createHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHousekeepingPlan(
      createHousekeepingPlanRequest?: CreateHousekeepingPlanRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateHousekeepingPlanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createHousekeepingPlan(
        createHousekeepingPlanRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HousekeepingPlansApi.createHousekeepingPlan']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHousekeepingPlanById(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HousekeepingPlanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHousekeepingPlanById(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HousekeepingPlansApi.getHousekeepingPlanById']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHousekeepingPlans(
      ids?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<HousekeepingPlanSummaryResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHousekeepingPlans(ids, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HousekeepingPlansApi.getHousekeepingPlans']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * HousekeepingPlansApi - factory interface
 */
export const HousekeepingPlansApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HousekeepingPlansApiFp(configuration)
  return {
    /**
     *
     * @param {string} id
     * @param {AmendHousekeepingPlanRequest} [amendHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    amendHousekeepingPlan(
      id: string,
      amendHousekeepingPlanRequest?: AmendHousekeepingPlanRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HousekeepingPlanResponse> {
      return localVarFp
        .amendHousekeepingPlan(id, amendHousekeepingPlanRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelHousekeepingPlan(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HousekeepingPlanResponse> {
      return localVarFp
        .cancelHousekeepingPlan(id, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateHousekeepingPlanRequest} [createHousekeepingPlanRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHousekeepingPlan(
      createHousekeepingPlanRequest?: CreateHousekeepingPlanRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateHousekeepingPlanResponse> {
      return localVarFp
        .createHousekeepingPlan(createHousekeepingPlanRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHousekeepingPlanById(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HousekeepingPlanResponse> {
      return localVarFp
        .getHousekeepingPlanById(id, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHousekeepingPlans(
      ids?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HousekeepingPlanSummaryResponse>> {
      return localVarFp.getHousekeepingPlans(ids, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * HousekeepingPlansApi - object-oriented interface
 */
export class HousekeepingPlansApi extends BaseAPI {
  /**
   *
   * @param {string} id
   * @param {AmendHousekeepingPlanRequest} [amendHousekeepingPlanRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public amendHousekeepingPlan(
    id: string,
    amendHousekeepingPlanRequest?: AmendHousekeepingPlanRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HousekeepingPlansApiFp(this.configuration)
      .amendHousekeepingPlan(id, amendHousekeepingPlanRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public cancelHousekeepingPlan(id: string, options?: RawAxiosRequestConfig) {
    return HousekeepingPlansApiFp(this.configuration)
      .cancelHousekeepingPlan(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateHousekeepingPlanRequest} [createHousekeepingPlanRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createHousekeepingPlan(
    createHousekeepingPlanRequest?: CreateHousekeepingPlanRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HousekeepingPlansApiFp(this.configuration)
      .createHousekeepingPlan(createHousekeepingPlanRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getHousekeepingPlanById(id: string, options?: RawAxiosRequestConfig) {
    return HousekeepingPlansApiFp(this.configuration)
      .getHousekeepingPlanById(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<string>} [ids]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getHousekeepingPlans(ids?: Array<string>, options?: RawAxiosRequestConfig) {
    return HousekeepingPlansApiFp(this.configuration)
      .getHousekeepingPlans(ids, options)
      .then(request => request(this.axios, this.basePath))
  }
}
